import { useCan } from "@refinedev/core";
import { Layout } from "antd";
import { type ReactNode, useState } from "react";
import { ADMIN_SIDER_COLLAPSED_WIDTH, ADMIN_SIDER_WIDTH } from "../theme";
import { AdminHeader } from "./AdminHeader";
import { AdminSider } from "./AdminSider";

type AdminLayoutProps = {
	children: ReactNode;
};

export function AdminLayout({ children }: AdminLayoutProps) {
	const [collapsed, setCollapsed] = useState(false);
	const { data: canStaff } = useCan({ resource: "staff", action: "list" });

	const siderWidth = collapsed
		? ADMIN_SIDER_COLLAPSED_WIDTH
		: ADMIN_SIDER_WIDTH;

	return (
		<Layout className="admin-shell" hasSider>
			<AdminSider
				collapsed={collapsed}
				canManageStaff={Boolean(canStaff?.can)}
			/>
			{/* Spacer for fixed sider */}
			<div
				style={{ width: siderWidth, flexShrink: 0, transition: "width 0.2s" }}
			/>
			<Layout style={{ minWidth: 0 }}>
				{/* Double-click brand area isn't available; use header click zone later if needed */}
				<button
					type="button"
					aria-label={collapsed ? "メニューを開く" : "メニューを閉じる"}
					onClick={() => setCollapsed((value) => !value)}
					style={{
						position: "fixed",
						insetInlineStart: siderWidth - 12,
						bottom: 24,
						zIndex: 1000,
						width: 24,
						height: 24,
						borderRadius: 12,
						border: "1px solid #e5e7eb",
						background: "#fff",
						cursor: "pointer",
						padding: 0,
						fontSize: 10,
						lineHeight: "22px",
						color: "#6b8c84",
						transition: "inset-inline-start 0.2s",
					}}
				>
					{collapsed ? "›" : "‹"}
				</button>
				<AdminHeader />
				<Layout.Content className="admin-content">{children}</Layout.Content>
			</Layout>
		</Layout>
	);
}
